module.exports = __webpack_public_path__ + "static/media/02_03.ce40cdb2.png";